/**
 * 查看更多
 * 两种功能：
 * 一是点击跳转查看更多 jumpMore
 * 二是展示固定的条目，点击查看更多展开所有条目
 */
import React from 'react';

export default class BtnMore extends React.Component {
    render() {
        const {url = '', text = '', isFold, callbackFn, eid = ''} = this.props;
        return (
            <div className="m-btn-more">
                {url ? (
                    <button
                        onClick={() => {
                            if(eid) {
                                QNRSK.manual(eid);
                            }
                            window.open(url);
                        }}>
                        {text}
                    </button>
                ) : (
                    <button
                        onClick={() => {
                            if(eid) {
                                QNRSK.manual(eid);
                            }
                            callbackFn && callbackFn();
                        }}>
                        {isFold ? '查看更多' : '收起'}
                    </button>
                )}
            </div>
        );
    }
}
